import React, { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { productApiSlice } from '../../features/product/productApiSlice';
import socketSetup from '../../socket-io/socket-io';

export const useProductSocket = () => {

    const dispatch = useDispatch();

    const invalidateProduct = useCallback(() => {
        dispatch(
            productApiSlice.util.invalidateTags([
                { type: "Product", id: "LIST" },
            ])
        );
    }, [dispatch]);

    useEffect(() => {
        if (!socketSetup) return;

        socketSetup.on("createProduct", invalidateProduct);
        socketSetup.on("updateProduct", invalidateProduct);
        socketSetup.on("deleteProduct", invalidateProduct);
        socketSetup.on("activateProduct", invalidateProduct);
        socketSetup.on("inactivateProduct", invalidateProduct);
        socketSetup.on("markOutOfStock", invalidateProduct);

        return () => {
            socketSetup.off("createProduct", invalidateProduct);
            socketSetup.off("updateProduct", invalidateProduct);
            socketSetup.off("deleteProduct", invalidateProduct);
            socketSetup.off("activateProduct", invalidateProduct);
            socketSetup.off("inactivateProduct", invalidateProduct);
            socketSetup.off("markOutOfStock", invalidateProduct);
        };
    }, [invalidateProduct]);
}
